export default "__VITE_ASSET__D6bnv1VF__"